export default __webpack_public_path__ + "static/media/join.e7c36065.png";